import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-rep-commission-paid',
  templateUrl: './rep-commission-paid.component.html',
  styleUrl: './rep-commission-paid.component.scss'
})
export class RepCommissionPaidComponent implements OnInit {

  // ================= FILTERS =================
  startDate = '';
  endDate = '';

  office_rep_name = '';
  rep_name = '';
  book_seller_name = '';

  reportType = 'Rep Commission Paid';

  currentDate = new Date();

  // ================= DATA =================
  filterData: any[] = [];
  groupedData: any[] = [];

  // ================= GRAND TOTAL =================
  grandTotal_invoice = 0;
  grandTotal_received = 0;
  grandTotal_commission = 0;
  grandTotal_paid = 0;
  grandTotal_unpaid = 0;

  constructor(
    private dialogRef: MatDialogRef<RepCommissionPaidComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {}

  // ================= INIT =================
  ngOnInit(): void {
    debugger

    this.startDate = this.data?.startDate ?? '';
    this.endDate = this.data?.endDate ?? '';

    this.rep_name = this.data?.rep_name ?? '';
    this.office_rep_name = this.data?.office_rep_name ?? '';

    this.book_seller_name = this.data?.book_seller_name ?? '';

    this.getCommissionData();
  }

  // ================= API CALL =================
  getCommissionData(): void {

    const req = {
      start_date: this.startDate,
      end_date: this.endDate,
      office_rep_name: this.office_rep_name,
      rep_name: this.rep_name,
      book_seller_name: this.book_seller_name
    };

    this.service.getAllRepBookCommission(req).subscribe({

      next: (res: any) => {
        this.filterData = res || [];
        this.groupCommissionData();
      },

      error: (err) => {
        console.error('Error loading report:', err);
      }

    });
  }

  // ================= GROUPING + TOTALS =================
  groupCommissionData(): void {

    // Reset Grand Total
    this.grandTotal_invoice = 0;
    this.grandTotal_received = 0;
    this.grandTotal_commission = 0;
    this.grandTotal_paid = 0;
    this.grandTotal_unpaid = 0;

    const officeMap = new Map<string, any>();

    this.filterData.forEach(item => {

      const office = item.office_rep_name || 'Unknown Office';
      const rep = item.rep_name || 'Unknown Representative';

      const invoice = Number(item.invoice_total) || 0;
      const received = Number(item.invoice_received_amt) || 0;
      const commission = Number(item.rep_commission_amt) || 0;
      const paid = Number(item.received_amt) || 0;
      const unpaid = Number(item.remaining_amt) || 0;

      // ================= OFFICE =================
      if (!officeMap.has(office)) {

        officeMap.set(office, {
          office_rep_name: office,
          repGroups: new Map(),

          total_invoice: 0,
          total_received: 0,
          total_commission: 0,
          total_paid: 0,
          total_unpaid: 0
        });

      }

      const officeObj = officeMap.get(office);

      // ================= REP =================
      if (!officeObj.repGroups.has(rep)) {

        officeObj.repGroups.set(rep, {
          rep_name: rep,
          records: [],

          repTotal_invoice: 0,
          repTotal_received: 0,
          repTotal_commission: 0,
          repTotal_paid: 0,
          repTotal_unpaid: 0
        });

      }

      const repObj = officeObj.repGroups.get(rep);

      // ================= RECORD =================
      repObj.records.push(item);

      // ================= REP TOTAL =================
      repObj.repTotal_invoice += invoice;
      repObj.repTotal_received += received;
      repObj.repTotal_commission += commission;
      repObj.repTotal_paid += paid;
      repObj.repTotal_unpaid += unpaid;

      // ================= OFFICE TOTAL =================
      officeObj.total_invoice += invoice;
      officeObj.total_received += received;
      officeObj.total_commission += commission;
      officeObj.total_paid += paid;
      officeObj.total_unpaid += unpaid;

      // ================= GRAND TOTAL =================
      this.grandTotal_invoice += invoice;
      this.grandTotal_received += received;
      this.grandTotal_commission += commission;
      this.grandTotal_paid += paid;
      this.grandTotal_unpaid += unpaid;

    });

    // Convert Map → Array
    this.groupedData = Array.from(officeMap.values()).map(o => ({
      ...o,
      repGroups: Array.from(o.repGroups.values())
    }));

  }

  // ================= PRINT =================
printPageA4(): void {
  const printContent = document.getElementById('print-section');
  if (!printContent) return;

  const printWindow = window.open('', '', 'width=1200,height=800');
  if (!printWindow) return;

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>.</title>
        <style>
          * {
            box-sizing: border-box;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          @page {
            size: A4 landscape;
            margin: 10mm;
          }

          body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
            font-size: 12px;
            color: #000;
            width: 100%;
          }

          /* HEADER TABLES */
          .header-table {
            width: 100%;
            border-collapse: collapse;
            table-layout: auto; /* Important for proper header sizing */
            margin-bottom: 5px;
          }

          .header-table th {
            padding: 6px 8px;
            text-align: center;
            font-size: 16px;
            font-weight: bold;
            border: 1px solid black;
          }

          .sub-header-table {
            width: 100%;
            border-collapse: collapse;
            table-layout: auto;
            margin-bottom: 10px;
          }

          .sub-header-table th {
            padding: 6px 8px;
            text-align: center;
            font-size: 14px;
            font-weight: bold;
            border: 1px solid black;
          }

          /* DATA TABLE */
          table.data-table {
            width: 98%;
            margin: 0 auto;
            border-collapse: collapse;
            border: 1px solid #000;
            table-layout: fixed;
          }

          th, td {
            border: 1px solid #000;
            padding: 4px 5px;
            white-space: normal;
            word-break: break-word;
            overflow-wrap: break-word;
            vertical-align: middle;
          }

          /* ALIGNMENTS */
          .text-left { text-align: left !important; }
          .text-right { text-align: right !important; }

          td.amount, th.amount { text-align: right !important; }

          /* COLUMN WIDTHS */
          th.invoice-date, td.invoice-date { width: 90px; text-align: center; }
          th.invoice-no, td.invoice-no { width: 90px; text-align: center; }
          th.book-seller, td.book-seller { width: 250px; text-align: left; }
          th.invoice-amount, td.invoice-amount,
          th.invoice-rec, td.invoice-rec,
          th.invoice-commission, td.invoice-commission,
          th.paid-commission, td.paid-commission { width: 100px; text-align: right; }
          th.commission-date, td.commission-date { width: 120px; text-align: center; white-space: normal; }

          thead { display: table-header-group; }
          tr { page-break-inside: avoid; }

          @media print {
            body { zoom: 1; }
            .noPrint { display: none !important; }
          }

        </style>
      </head>
      <body>
        ${printContent.innerHTML}
      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();

  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 600);
}





  // ================= EXPORT EXCEL =================
  exportExcel(filename: string): void {

    const element = document.getElementById('print-section');

    if (!element) return;

    const ws = XLSX.utils.table_to_sheet(element);

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, 'Report');

    XLSX.writeFile(wb, `${filename}.xlsx`);
  }

}
